<template>
    <div class="bg-grey">
    
        <CRow class="m-0 justify-content-center align-items-center">
            <CCol sm="12" xs="6" class="text-right">
                <h5 class="custom-18px poppin-font mt-2 text-center" style="padding-top: 40px;">
                    <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
                    <span style="margin-top:20px">Create Account</span>
                </h5>
    
            </CCol>
    
            <CCol sm="8" class="text-center mt-3" style="width: 90%;background-size: cover; margin: auto;">
                <!-- Additional content -->
                <div class="p-2 text-left">
                    <label class="custom-14px text-left">Full Name</label>
                    <input type="text" placeholder="Enter your full name" class="custom-input-app" v-model="Name" />
                    <br />

                    <label class="custom-14px text-left">Email</label>
                    <input type="text" placeholder="Enter your email" class="custom-input-app" v-model="Email" />
                    <br />
                    
                    <label class="custom-14px text-left">Phone Number</label>
                    <input type="number" placeholder="Enter your phone number" class="custom-input-app" v-model="Phone" />
                    <br />

                    <label class="custom-14px text-left">Password</label>
                    <input type="password" placeholder="Enter your password" class="custom-input-app" v-model="Password" />
                    <br />

                    <label class="custom-14px text-left">Confirm Password</label>
                    <input type="password" placeholder="Confirm your password" class="custom-input-app" v-model="ConfirmPassword" />


                    <CRow class="p-2 mt-3">
                        <div class="label-custom-header-subtitle"><input type="checkbox" class="mr-2"/>By agreeing to the terms and conditions, you are entering into a legality binding 
                            contract with the service provider</div>
                      
                       
                    </CRow>
                    <div class="mt-2 text-center">
                        <div @click="registerAccount()" class="button-border-blue text-white">
                            <label class="mt-2">Create</label>
                        </div>
                        <br />
                    </div>
                    <div style="margin:0 auto;" class="text-center m-0">
                            <img style="max-width:100%" src="../assets/img/Or.png" />
                        </div>
                        <CRow>
                            <div style="width:50%">
                            <div class="text-center bg-white b-20 p-2 m-20" style="border:none;margin:10px">
                                <img style="width:25px" src="../assets/img/google.png" class="mt-1 mb-1 mr-2"/>
                                </div>
                            </div>
                            <div style="width:50%">
                                <div class="text-center bg-white b-20 p-2 m-20" style="border:none;margin:10px">
                                    <img style="width:25px" src="../assets/img/apple.png" class="mt-1 mb-1 ml-2"/>
                                </div>
                            </div>
                        </CRow>
                        <div class="text-center">
                           <label class="custom-14px poppin-font"> Don’t have an account? <a @click="GoToRegister()" href="">Create Now</a></label>
                        </div>
                
    
    
                 
                </div>
            </CCol>
        </CRow>
    </div>
</template>


<script>
export default ({
    data() {
        return {
            isLanguagePopupVisible: false,
            Name: "",
            Email: "",
            Phone: "",
            Password: "",
            UserType: "",
            ConfirmPassword: "",

        }

    },
    methods: {
        GoToPrevious() {
            this.$router.go(-1);
        },
       
        GoToLogin() {
            this.$router.push("/Login");
        },
        GoToChangePassword() {
            // Close the popup and backdrop
            this.$router.push("/ChangePassword");
        },

        GoToLogin()
      {
          this.$router.push("/Login");
      },
    
      registerAccount() {

      const formData = new FormData();

      if (this.Name === "" || this.Email === "" || this.Phone === "" || this.Password === "") {
        this.Error = true;
        this.Message = "Please fill up the form !";
      } else {
        this.buttonLabel = 'Processing';
        formData.append("name", this.Name);
        formData.append("email", this.Email);
        formData.append("phone", this.Phone);
        formData.append("userType", this.$route.query.type);
        formData.append("password", this.Password);
        formData.append("languageId", this.$route.query.language);
        formData.append("countryId", this.$route.query.countryId);


        this.$API
          .post(this.$Register, formData, { withCredentials: true })
          .then((response) => {
            if (response.data.status === 400) {
              this.Loading = false;
              this.Message = response.data.message;
              this.Error = true;
            }
            if (response.status == 200) {
              if (response.data.status !== 400) {

                if (
                  this.$route.query.targetUrl != "" &&
                  (this.$route.query.targetUrl != null) &
                    (this.$route.query.targetUrl != undefined)
                ) {
                  this.$router.push(this.$route.query.targetUrl);
                } else {
                  this.GoToLogin();
                }
                






               
              } else {
                this.Loading = false;
                this.Message = response.data.message;
                this.Error = true;
              }
            } else {
              this.Loading = false;
              this.Error = true;
              this.Message = response.data.message;
            }
          })
          .catch((error) => {
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      }
    },

    }
})
</script>
